import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/sent-desktop.svg'


const _hoisted_1 = {
  class: "btn btn-primary",
  type: "button",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    id: "modalSentDesktop",
    idName: "modalSentDesktop"
  }, {
    "modal-header": _withCtx(() => _cache[0] || (_cache[0] = [
      _createElementVNode("button", {
        class: "btn-close",
        type: "button",
        "data-bs-dismiss": "modal",
        "aria-label": "Close"
      }, null, -1)
    ])),
    "modal-body": _withCtx(() => _cache[1] || (_cache[1] = [
      _createElementVNode("h2", null, "Para emitir um novo Certificado Digital através de Token ou Cartão, você; vai precisar acessar esta página pelo computador ou notebook.", -1),
      _createElementVNode("img", {
        src: _imports_0,
        alt: "menina sorrindo"
      }, null, -1)
    ])),
    "modal-footer": _withCtx(() => [
      _createElementVNode("button", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "me-2" }, "Fechar", -1)),
        _createVNode(_component_Icon, { name: "x" })
      ])
    ]),
    _: 1
  }))
}